import React, { memo } from 'react';
import {
  COLORS, EDGE_WIDTH, DASH_PATTERN, STROKE_WIDTH,
} from '../../lib/network/constants';

const HIT_WIDTH = 12;
const HANDLE_HIT = 10;
const HANDLE_RADIUS = 4.5;

export function Marker({ marker, color }) {
  if (marker.type === 'circle') {
    return <circle cx={marker.cx} cy={marker.cy} r={marker.r} fill={color} />;
  }
  return <polygon points={marker.points} fill={color} />;
}

function EdgeView({
  edge, geometry, selected, hovered, scale = 1, showHandle,
}) {
  let color = edge.color || COLORS.edge;
  let width = EDGE_WIDTH.normal;
  if (selected) {
    color = COLORS.highlight;
    width = EDGE_WIDTH.selected;
  } else if (hovered) {
    color = COLORS.hover;
    width = EDGE_WIDTH.hover;
  }
  const { path, marker, midpoint } = geometry;
  const k = scale || 1;

  return (
    <g data-edge-id={String(edge.id)} style={{ cursor: 'pointer' }}>
      <path
        data-hit="true"
        d={path}
        fill="none"
        stroke="transparent"
        strokeWidth={HIT_WIDTH}
        pointerEvents="stroke"
      />
      <path
        d={path}
        fill="none"
        stroke={color}
        strokeWidth={width}
        strokeDasharray={edge.dashes ? DASH_PATTERN : undefined}
      />
      <Marker marker={marker} color={color} />
      {midpoint && (
        <g data-edge-handle={String(edge.id)} style={{ cursor: 'grab' }}>
          <circle
            cx={midpoint.x}
            cy={midpoint.y}
            r={HANDLE_HIT / k}
            fill="transparent"
          />
          {showHandle && (
            <circle
              cx={midpoint.x}
              cy={midpoint.y}
              r={HANDLE_RADIUS / k}
              fill="white"
              stroke={color}
              strokeWidth={STROKE_WIDTH / k}
            />
          )}
        </g>
      )}
    </g>
  );
}

export default memo(EdgeView);
